module.exports = __webpack_public_path__ + "media/images/games/fifa-20/background-05a1e918f7c0d89fe80aa356e0a61c66.jpg";